module.exports = __webpack_public_path__ + "img/icon-chat.b7e03341.svg";